enum ErrorCode {
	WEBSERVICE_INVALID_DOCUMENT_ID = -50,
	WEBSERVICE_SESSION_TOKEN_NOT_FOUND = -60,
	WEBSERVICE_SESSION_TIMEOUT = -61,
	WEBSERVICE_SESSION_EXPIRED = -62,
	WEBSERVICE_SESSION_UNABLE_TO_CREATE = -63,
	WEBSERVICE_SESSION_TOKEN_NOT_ALLOWED = -64,
	WEBSERVICE_SESSION_UNKNOWN_ERROR = -65,
	WEBSERVICE_SESSION_TOKEN_NOT_PROVIDED = -66,
	PDF_READ = -5000,
	PDF_PASSWORD_OWNER = -5007,
	PDF_PASSWORD_USER = -5008,
	PDF_PASSWORD_MISSING = -5009,
	PDF_CERTIFICATE_KEYPAIR_FAILURE = -5052,
	PDF_CERTIFICATE_PRIVATE_KEY_FAILURE = -5053,
	PDF_CERTIFICATE_CERTIFICATE_FAILURE = -5054,
	PDF_CERTIFICATE_KEYPAIR_MISSING = -5055,
	PDF_CERTIFICATE_RECIPIENT_NOT_MATCHING = -5060,
	WEBSERVICE_SESSION_TOKEN_INCORRECT_CLAIM = -9002,
	ERR_CANCELED = "ERR_CANCELED"
}

export default ErrorCode;